import { useState } from "react";

import { mixpanelInstance } from "../../shared/utils/mixpanel";
import PAL from "../components/PAL";
import { useNavigate } from "react-router-dom";
import IntroTeacher from "../components/IntroTeacher";

const OnboardingTeacher = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0);

  if (step === 0)
    return (
      <IntroTeacher
        next={() => {
          mixpanelInstance.track("ED - OT - Decouvrir");
          setStep(step + 1);
        }}
      />
    );

  if (step === 1)
    return (
      <PAL
        next={() => {
          mixpanelInstance.track("ED - OT - Fin PAL");
          navigate("/v2/home");
        }}
      />
    );
};

export default OnboardingTeacher;
